// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SettingOutlined from '/app/node_modules/.pnpm/@ant-design+icons@4.8.3_react-dom@19.2.8_react@19.2.8__react@19.2.8/node_modules/@ant-design/icons/es/icons/SettingOutlined';
export default { SettingOutlined };
